import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { orgAdminService, orgAdminStorage } from "../../features/org-admin/service";

/** The org console's own chrome. Intentionally a much smaller shell than
 *  AdminLayout (three pages, no hubs) and it never renders any superadmin
 *  component, so nothing here can leak the superadmin session. */
const NAV_ITEMS: { path: string; label: string }[] = [
  { path: "/org-admin/dashboard", label: "Dashboard" },
  { path: "/org-admin/candidates", label: "Candidates" },
  { path: "/org-admin/members", label: "Members" },
];

const OrgAdminLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const orgAdminUser = orgAdminStorage.getUser();

  const handleLogout = () => {
    orgAdminService.logout();
    navigate("/org-admin/login");
  };

  return (
    <div className="min-h-screen bg-gray-950">
      <header className="border-b border-gray-800 bg-gray-900">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-16 flex items-center justify-between gap-4">
            <div className="min-w-0">
              <span className="block text-lg font-bold bg-gradient-to-r from-indigo-400 to-cyan-400 bg-clip-text text-transparent truncate">
                {orgAdminUser?.org_name || "Organization"}
              </span>
              <span className="block text-xs text-gray-500 truncate">Organization console</span>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <div className="hidden sm:block text-right min-w-0">
                <p className="text-sm font-medium text-white truncate">{orgAdminUser?.name || "Org Admin"}</p>
                <p className="text-xs text-gray-500 truncate">{orgAdminUser?.email}</p>
              </div>
              <button
                onClick={handleLogout}
                className="px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
          <nav className="flex items-center gap-1 -mb-px overflow-x-auto">
            {NAV_ITEMS.map((item) => {
              const active = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-3 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                    active
                      ? "border-indigo-400 text-indigo-400"
                      : "border-transparent text-gray-400 hover:text-white"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </header>
      <main className="max-w-6xl mx-auto p-4 sm:p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default OrgAdminLayout;
